/* PetalFinger · pf-product.js
   商品页逻辑：规格选择与价格同步、加购（含配件）、吸底加购条、相册、
   尺码指南、送达日期、包邮进度、一起购买（FBT）。依赖 pf-base.js。 */
(function () {
  if (window.PFProduct) return;
  window.PFProduct = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function businessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; }
    return d;
  }
  function fmtDate(d, locale) { try { return d.toLocaleDateString(locale || 'en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } }

  if (!customElements.get('pf-product')) {
    customElements.define('pf-product', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        try { this.variants = JSON.parse(this.dataset.variants || '[]'); } catch (e) { this.variants = []; }
        this.optionCount = parseInt(this.dataset.options || '1', 10);
        this.form = this.querySelector('form[data-pf-form]');
        this.idInputs = $$('form input[name="id"]', this);
        this.atc = this.querySelector('[data-pf-atc]');
        this.sticky = this.querySelector('[data-pf-sticky]');
        this.selected = [];
        for (var i = 0; i < this.optionCount; i++) { var on = this.querySelector('[data-pf-opt][data-index="' + i + '"] .is-on'); this.selected[i] = on ? on.dataset.value : null; }
        this.addEventListener('click', function (e) {
          var o = e.target.closest('[data-pf-opt] button[data-value]');
          if (o) { self.pick(o); return; }
          var q = e.target.closest('[data-pf-qty-btn]');
          if (q) { var inp = self.querySelector('[data-pf-qty-input]'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.pfQtyBtn, 10)); return; }
          var s = e.target.closest('[data-pf-sticky-atc]');
          if (s) { self.submit(s); return; }
          var th = e.target.closest('[data-pf-thumb]');
          if (th) { self.goTo(parseInt(th.dataset.pfThumb, 10)); return; }
          var sg = e.target.closest('[data-pf-open-size]');
          if (sg) { e.preventDefault(); self.openSizeGuide(false); return; }
          if (e.target.closest('.pf-drawer__close')) { if (window.PF) PF.closeDrawers(); }
        });
        if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(self.atc); });
        var mm = this.querySelector('[data-pf-mm]');
        if (mm) { var upd = function () { self.recommend(parseFloat(mm.value)); }; mm.addEventListener('input', upd); upd(); }
        this.initGallery();
        this.initSticky();
        this.initEta();
        this.initFreeShip();
        this.update(false);
      }
      currentVariant() {
        var sel = this.selected, vs = this.variants;
        for (var i = 0; i < vs.length; i++) { var ok = true; for (var k = 0; k < this.optionCount; k++) { if (sel[k] && vs[i].o[k] !== sel[k]) { ok = false; break; } } if (ok) return vs[i]; }
        return null;
      }
      pick(btn) {
        var idx = parseInt(btn.closest('[data-pf-opt]').dataset.index, 10);
        this.selected[idx] = btn.dataset.value;
        $$('button', btn.closest('[data-pf-opt]')).forEach(function (b) { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-checked', b === btn); });
        this.update(true);
        if (idx === 0) this.openSizeGuide(true);
      }
      /* 尺码指南：auto=true 表示由选尺码触发（受 data-pf-auto-size 控制：off / once / always） */
      openSizeGuide(auto) {
        var d = this.querySelector('[data-pf-drawer="size"]') || document.querySelector('[data-pf-drawer="size"]');
        if (!d || !window.PF) return;
        var size = this.selected[0] || '';
        var chip = d.querySelector('[data-pf-size-sel]');
        if (chip) { if (size) { chip.textContent = (chip.dataset.label || '{size}').replace('{size}', size); chip.hidden = false; } else { chip.hidden = true; } }
        $$('.pf-size-table tbody tr', d).forEach(function (tr) { tr.classList.toggle('is-on', !!size && (tr.dataset.size || '').toLowerCase() === size.toLowerCase()); });
        if (auto) {
          var mode = this.dataset.pfAutoSize || 'off';
          if (mode === 'off') return;
          if (mode === 'once') { try { if (sessionStorage.getItem('pf_sg_auto')) return; sessionStorage.setItem('pf_sg_auto', '1'); } catch (e) { if (this._sgShown) return; this._sgShown = true; } }
          if (document.body.classList.contains('pf-lock')) return;
          setTimeout(function () { PF.openDrawer(d); }, 180);
        } else { PF.openDrawer(d); }
      }
      update(fromUser) {
        var v = this.currentVariant(), self = this;
        /* availability of other option values given current selection */
        $$('[data-pf-opt]', this).forEach(function (g) {
          var idx = parseInt(g.dataset.index, 10);
          $$('button[data-value]', g).forEach(function (b) {
            var avail = self.variants.some(function (x) { if (!x.a) return false; for (var k = 0; k < self.optionCount; k++) { if (k === idx) { if (x.o[k] !== b.dataset.value) return false; } else if (self.selected[k] && x.o[k] !== self.selected[k]) return false; } return true; });
            b.classList.toggle('is-soldout', !avail);
          });
        });
        $$('[data-pf-sel]', this).forEach(function (el) { el.textContent = self.selected.filter(Boolean).join(' · '); });
        var price = this.querySelector('[data-pf-price]'), cmp = this.querySelector('[data-pf-compare]'), save = this.querySelector('[data-pf-save]');
        if (v) {
          this.idInputs.forEach(function (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); });
          $$('[data-pf-sel-single]', this).forEach(function (el) { el.textContent = self.selected[parseInt(el.dataset.pfSelSingle, 10)] || ''; });
          var o2 = this.querySelector('[data-pf-sel-opt2]'); if (o2 && v.o[1]) o2.textContent = v.o[1];
          if (price) price.textContent = PF.money(v.p);
          var hasCmp = v.c && v.c > v.p;
          if (cmp) { cmp.textContent = hasCmp ? PF.money(v.c) : ''; cmp.hidden = !hasCmp; }
          if (save) { save.hidden = !hasCmp; if (hasCmp) save.textContent = (save.dataset.label || 'Save {pct}%').replace('{pct}', Math.round((1 - v.p / v.c) * 100)); }
          var pw = this.querySelector('[data-pf-perwear]'); if (pw) pw.textContent = (pw.dataset.label || '≈ {amount} per wear when worn {n}×').replace('{amount}', PF.money(Math.round(v.p / (parseInt(pw.dataset.wears, 10) || 3)))).replace('{n}', pw.dataset.wears || 3);
          if (this.atc) { this.atc.disabled = !v.a; var t = this.atc.querySelector('[data-pf-atc-text]'); if (t) t.textContent = v.a ? (this.atc.dataset.add || 'Add to cart') + (this.atc.dataset.showPrice === 'true' ? ' · ' + PF.money(v.p) : '') : (this.atc.dataset.soldout || 'Sold out'); }
          if (this.sticky) { var sp = this.sticky.querySelector('[data-pf-sticky-price]'); if (sp) sp.innerHTML = PF.money(v.p) + (hasCmp ? ' <s>' + PF.money(v.c) + '</s>' : ''); var si = this.sticky.querySelector('img'); if (si && v.img) si.src = v.img; var sb = this.sticky.querySelector('[data-pf-sticky-atc]'); if (sb) { sb.disabled = !v.a; sb.textContent = v.a ? (sb.dataset.add || 'Add to cart') : (sb.dataset.soldout || 'Sold out'); } }
          if (fromUser && v.mid) this.goToMedia(v.mid);
          if (fromUser && window.history && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
          this.updateFreeShip(v.p);
        } else if (this.atc) {
          this.atc.disabled = true; var tt = this.atc.querySelector('[data-pf-atc-text]'); if (tt) tt.textContent = this.atc.dataset.unavailable || 'Unavailable';
        }
      }
      submit(btn) {
        var v = this.currentVariant(); if (!v || !v.a) return;
        var qty = parseInt((this.querySelector('[data-pf-qty-input]') || {}).value, 10) || 1;
        var items = [{ id: v.id, quantity: qty }];
        var addon = this.querySelector('[data-pf-addon]:checked'); if (addon && addon.value) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
        var btns = [this.atc, this.querySelector('[data-pf-sticky-atc]')].filter(Boolean);
        btns.forEach(function (b) { b.classList.add('is-loading'); });
        PF.add(items).then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.classList.add('is-done'); setTimeout(function () { b.classList.remove('is-done'); }, 1500); }); })
          .catch(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
      }
      /* gallery: one scroll-snap track for both mobile and desktop + thumbs */
      initGallery() {
        var self = this, track = this.querySelector('[data-pf-track]'); if (!track) return;
        this.track = track; this.slides = $$('[data-pf-slide]', track);
        var counter = this.querySelector('[data-pf-counter]');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.intersectionRatio > .6) { var i = self.slides.indexOf(en.target); self.current = i; if (counter) counter.textContent = (i + 1) + ' / ' + self.slides.length; $$('[data-pf-thumb]', self).forEach(function (t) { t.classList.toggle('is-on', parseInt(t.dataset.pfThumb, 10) === i); }); var th = self.querySelector('[data-pf-thumb="' + i + '"]'); if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } });
        }, { root: track, threshold: [.6] });
        this.slides.forEach(function (s) { io.observe(s); });
        var prev = this.querySelector('[data-pf-gal-prev]'), next = this.querySelector('[data-pf-gal-next]');
        if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, (self.current || 0) - 1)); });
        if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.slides.length - 1, (self.current || 0) + 1)); });
      }
      goTo(i) { var s = this.slides && this.slides[i]; if (!s) return; this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' }); }
      goToMedia(mid) { var i = (this.slides || []).findIndex(function (s) { return s.dataset.mediaId === String(mid); }); if (i > -1) this.goTo(i); }
      /* sticky ATC: show when the main button is out of view */
      initSticky() {
        var self = this; if (!this.sticky || !this.atc) return;
        var io = new IntersectionObserver(function (en) { self.sticky.classList.toggle('is-show', !en[0].isIntersecting); }, { threshold: 0 });
        io.observe(this.atc);
      }
      initEta() {
        var el = this.querySelector('[data-pf-eta]'); if (!el) return;
        var now = new Date(), min = parseInt(el.dataset.min, 10) || 7, max = parseInt(el.dataset.max, 10) || 14, lead = parseInt(el.dataset.lead, 10) || 0;
        el.textContent = fmtDate(businessDays(now, min + lead), el.dataset.locale) + ' – ' + fmtDate(businessDays(now, max + lead), el.dataset.locale);
      }
      initFreeShip() {
        var self = this, el = this.querySelector('[data-pf-fs]'); if (!el) return;
        this.fs = el; this.fsThreshold = parseInt(el.dataset.threshold, 10) || 0;
        document.addEventListener('pf:cart', function () { var v = self.currentVariant(); self.updateFreeShip(v ? v.p : 0); });
        if (window.PF && !PF.cart) PF.getCart();
      }
      updateFreeShip(price) {
        var el = this.fs; if (!el || !this.fsThreshold) return;
        var inCart = (window.PF && PF.cart) ? PF.cart.items_subtotal_price : 0, total = inCart + (price || 0), left = Math.max(0, this.fsThreshold - total);
        var t = el.querySelector('[data-pf-fs-text]'), b = el.querySelector('[data-pf-fs-bar]');
        if (t) t.innerHTML = left <= 0 ? '<b>' + (el.dataset.done || 'This order ships free ✓') + '</b>' : (el.dataset.msg || 'Add {amount} more for free shipping').replace('{amount}', '<b>' + PF.money(left) + '</b>');
        if (b) b.style.width = Math.min(100, total / this.fsThreshold * 100) + '%';
      }
      recommend(mm) {
        var out = this.querySelector('[data-pf-mm-out]'); if (!out) return;
        var table = (out.dataset.sizes || 'XS:14.4,S:15.4,M:16.4,L:99').split(',').map(function (s) { var p = s.split(':'); return { l: p[0], max: parseFloat(p[1]) }; });
        var rec = table.filter(function (r) { return mm <= r.max; })[0] || table[table.length - 1];
        out.innerHTML = (out.dataset.label || 'Thumb <b>{mm} mm</b> → we recommend size <b>{size}</b>').replace('{mm}', mm).replace('{size}', rec.l);
        var v = this.querySelector('[data-pf-mm-val]'); if (v) v.textContent = mm + ' mm';
      }
    });
  }

  /* ---------- frequently bought together ---------- */
  $$('[data-pf-fbt]').forEach(function (box) {
    var total = box.querySelector('[data-pf-fbt-total]'), btn = box.querySelector('[data-pf-fbt-add]'), bundlePct = parseInt(box.dataset.bundlePct || '0', 10), bundleQty = parseInt(box.dataset.bundleQty || '0', 10), fs = parseInt(box.dataset.freeShipping || '0', 10);
    function rows() { return $$('[data-pf-fbt-row]', box).filter(function (r) { return r.querySelector('input[type=checkbox]').checked; }); }
    function sum() {
      var rs = rows(), t = rs.reduce(function (a, r) { var s = r.querySelector('select'); return a + parseInt(s ? s.selectedOptions[0].dataset.price : r.dataset.price, 10); }, 0);
      var html = '';
      if (bundlePct && bundleQty && rs.length >= bundleQty) html = '<s class="pf-muted">' + PF.money(t) + '</s> ' + PF.money(Math.round(t * (100 - bundlePct) / 100)) + ' <small>(' + bundlePct + '% off)</small>';
      else html = PF.money(t) + (fs && t >= fs ? ' · <span style="color:var(--pf-ok)">' + (box.dataset.fsLabel || 'free shipping ✓') + '</span>' : '');
      if (total) total.innerHTML = (box.dataset.totalLabel || 'Total') + ' ' + html;
      if (btn) btn.disabled = !rs.length;
    }
    box.addEventListener('change', sum);
    if (btn) btn.addEventListener('click', function () {
      var items = rows().map(function (r) { var s = r.querySelector('select'); return { id: parseInt(s ? s.value : r.dataset.variant, 10), quantity: 1 }; });
      if (!items.length) return;
      btn.classList.add('is-loading');
      PF.add(items).then(function () { btn.classList.remove('is-loading'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1500); }).catch(function () { btn.classList.remove('is-loading'); });
    });
    sum();
  });
})();
